import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class DeliveryDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(CrudlStatus.VIEW, bean);
          }
        }}
      >
        <div className="ui-g-12">
          <h2>Delivery Summary: </h2>
          <label />

          <div className="ui-g-2 row"></div>
          <div className="ui-g-8 row">
            <div className="ui-g-4 cell">
              <b style={{ float: "right" }}>Description: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Purchase Order No: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Customer Reference No: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Status: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Ship Together: </b>
            </div>

            <div className="ui-g-4 cell">
              <label>{bean.shortDescription || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.purchaseOrderNo || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.clientReferenceNumber || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.status || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>
                {format.getBooleanValue(bean, "shipTogether").toString() ||
                  "Not Set"}
              </label>
            </div>
            <div className="ui-g-4 cell">
              <b style={{ float: "right" }}>Date Order Recieved: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Client: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Site: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Building: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Location: </b>
            </div>
            <div className="ui-g-4 cell">
              <label>{bean.dateOrderReceivedToDisplay || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(
                  bean.customerDetails,
                  "businessName"
                ) || "Not Set"}
              </label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(bean.siteDetails, "siteName") ||
                  "Not Set"}
              </label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(bean.buildingDetails, "name") ||
                  "Not Set"}
              </label>
              <br></br>
              <br></br>
              <label>
                {format.getEmbeddedProperty(bean.locationDetails, "name") ||
                  "Not Set"}
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/UI/DeliveryDisplay.js